<script>
/* COMPOSANTS */

/* MIXINS */
import utilsMixin from '@mixins/utilsMixin';
import permissionsMixin from '@mixins/permissionsMixin';
import litigeStatusConst from '@mixins/const/litigeStatusConst';
import onboardingStepsConst from '@mixins/const/onboardingStepsConst';
import traceConst from '../../../mixins/const/traceConst';

/* SERVICES */

export default {
  props: {
    owner: {
      required: true,
    },
  },
  components: {},
  mixins: [utilsMixin, permissionsMixin, litigeStatusConst, onboardingStepsConst, traceConst],
  mounted() {},
  computed: {
    priority() {
      if (this.owner.onboardingCompleted === true) return 'priority-low';
      if (this.owner.formuleChosen === true) return 'priority-high';
      if (this.owner.statusProspect === 'NOUVEAU' || this.owner.onboardingOpen === true) return 'priority-medium';
      if (this.owner.statusProspect === 'PERDU') return 'priority-critical';
      // Statut des anciens hôtes
      if (this.owner.status === 'CUSTOMER') return 'priority-low';
      return 'priority-medium';
    },
    priorityText() {
      if (this.owner.onboardingCompleted === true) return 'Gagné';
      if (this.owner.formuleChosen === true) return 'En cours';
      if (this.owner.statusProspect === 'NOUVEAU' || this.owner.onboardingOpen === true) return 'Nouveau';
      if (this.owner.statusProspect === 'PERDU') return 'Perdu';
      // Statut des anciens hôtes
      if (this.owner.status === 'CUSTOMER') return 'Gagné';
      return 'Nouveau';
    },
    contactDisplay() {
      let contact = this.owner.contactList[0];
      return contact?.display;
    },
    companyDisplay() {
      if (this.priorityText === 'Nouveau') return '';
      return this.owner.currentOfferDisplay ?? this.owner.offerDisplay;
    },
    dateCreatedDisplay() {
      return 'Créé il y a ' + this.fromNow(this.owner.dateCreated);
    },
  },
  methods: {},
};
</script>

<template>
  <!-- Composant dynamique pour désactiver le lien si l'utilisateur est un hôte -->
  <component
    :is="this.isCommercial() && this.owner.status === 'CUSTOMER' ? 'div' : 'router-link'"
    :to="{name: this.owner.status === 'CUSTOMER' ? 'ownerPage' : 'prospectPage', params: {ownerId: this.owner.id}}"
    class="nohover">
    <div class="flex flex-col gap-2.5 p-3 rounded-lg bg-white" :key="this.owner.dateCreated">
      <div class="flex justify-between items-center">
        <span class="font-sf text-base text-grey-900 font-590 priority-low px-4 py-2 rounded-3xl" :class="[priority]">
          {{ this.priorityText }}
        </span>
      </div>
      <div class="flex gap-4 items-center">
        <span class="text-grey-900 text-md font-medium"> {{ this.contactDisplay }} </span>
      </div>
      <div v-if="(this.isGas() || this.isCommercial) && this.companyDisplay" class="flex gap-4 items-center">
        <span class="flex font-regular text-base text-grey-900 capitalize font-bold">
          {{ this.companyDisplay }}
        </span>
      </div>
      <div
        class="flex md:flex-col lg:flex-row flex-col items-start md:items-start lg:items-center gap-2"
        v-if="this.owner.onboardingId">
        <span class="flex font-regular text-md text-grey-900 capitalize">
          Onboarding n°{{ this.owner.onboardingId }}
        </span>
        <span class="flex font-regular text-md text-grey-900 capitalize hidden lg:block">/</span>
        <span
          class="flex font-regular text-md text-grey-900"
          v-if="this.owner.stepReached && priority !== 'priority-low'"
          >{{ displayForOnboardingStepsConst(this.owner.stepReached) }}
          <template v-if="this.owner.currentStep">({{ this.owner.currentStep }}/{{ this.owner.totalSteps }})</template>
        </span>
      </div>
      <div
        class="flex md:flex-col xl:flex-row flex-col items-start md:items-start xl:items-center gap-2"
        v-if="this.owner.onboardingId">
        <span
          class="text-grey-400 flex items-center text-base font-regular"
          :title="displayDateTime(this.owner.dateCreated)">
          {{ this.displayDateTime(this.owner.dateCreated) }}
        </span>
        <span class="flex font-regular text-base text-grey-400 capitalize hidden xl:block">/</span>
        <span class="flex font-regular text-base text-grey-400" v-if="this.owner.lastActivity">
          {{ this.owner.lastActivity }}
          <template v-if="this.owner.lastActivityDate">({{ displayDateTime(this.owner.lastActivityDate) }})</template>
        </span>
      </div>
    </div>
  </component>
</template>
